var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconChartOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.004,
    height: 17.581,
    viewBox: "0 0 23.004 17.581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_51911",
    "data-name": "Group 51911",
    transform: "translate(0 0.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72299",
    "data-name": "Path 72299",
    d: "M184.79,102.548l-3.482-3.39v14.613a.622.622,0,1,1-1.243,0V99.158l-3.482,3.39a.622.622,0,0,1-.868-.891l4.538-4.418.006,0h0a.621.621,0,0,1,.2-.127.046.046,0,0,0,.014,0,.617.617,0,0,1,.2-.041h.029a.612.612,0,0,1,.2.041.041.041,0,0,1,.015,0l.011,0a.618.618,0,0,1,.186.124s0,0,.006,0l4.537,4.418h0a.622.622,0,0,1-.868.891Z",
    transform: "translate(-163.012 -97.571)",
    fill: "#202124",
    stroke: "#202124",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51912",
    "data-name": "Group 51912",
    transform: "translate(-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72308",
    "data-name": "Path 72308",
    d: "M341.606,484.09h9.016a.945.945,0,0,1,0,1.89h-9.016a.945.945,0,0,1,0-1.89Z",
    transform: "translate(-336.669 -469.158)",
    fill: "#202124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72306",
    "data-name": "Path 72306",
    d: "M341.551,332.89h6.792a.947.947,0,0,1,0,1.89h-6.792a.947.947,0,0,1,0-1.89Z",
    transform: "translate(-334.335 -322.958)",
    fill: "#202124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72307",
    "data-name": "Path 72307",
    d: "M341.544,182.31H346.6a.948.948,0,0,1,0,1.89h-5.055a.948.948,0,0,1,0-1.89Z",
    transform: "translate(-332.586 -177.378)",
    fill: "#202124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72309",
    "data-name": "Path 72309",
    d: "M341.487,31.109h3.163a.954.954,0,0,1,0,1.89h-3.163a.954.954,0,0,1,0-1.89Z",
    transform: "translate(-330.582 -31.177)",
    fill: "#202124"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChartOrder);
export default __webpack_public_path__ + "static/media/icon-chart-order.822e9e15.svg";
export { ForwardRef as ReactComponent };